<form-control-container #container [control]="controlInstance" [class.readonly]="isReadonlyValue">
  <div label-extension>
    <ng-content select="[label-extension]"></ng-content>
  </div>
  <ng-container *ngIf="!isReadonlyValue">
    <input id="typeahead-basic" autocomplete="turn-off" (selectItem)="onSelectAddress($event)" [resultFormatter]="formatResult" type="text"
      class="form-control" [(ngModel)]="value" [ngClass]="{invalid: invalid}" [ngbTypeahead]="search" [attr.maxLength]="maxLength" />      
      <ng-content select="[after]"></ng-content>
  </ng-container>
  <ng-container *ngIf="isReadonlyValue">
    <span class="readonly-value">{{value}}</span>    
  </ng-container>
</form-control-container>